export const commonEnvironment = {
  useDevTools: false,
  sentry: undefined as string | undefined,
  version: '19.0.79',
  authServerRealm: 'wwag',
  authServerClient: 'wwag-work-client',
  bearerExcludedUrls: ['maps.googleapis.com'],
  serverApiUrl: '',
  envName: '',
  authServerUrl: '',
  updatePollingInterval: 60,
  updatePollingIntervalDelay: 10,
  agGridLicenceKey:
    'Using_this_{AG_Grid}_Enterprise_key_{AG-092268}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Walter_Wettstein_AG}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{WWAG-Work}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{WWAG-Work}_need_to_be_licensed___{WWAG-Work}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{29_July_2026}____[v3]_[01]_MTc4NTI3OTYwMDAwMA==b57173d078bfcbb43e97c9a7aefc9fa2',
  wettstei: {
    authRealm: 'wwag',
    authClientId: 'mlink',
    mlinkApiUrl: '',
  },
  firebaseConfig: {
    apiKey: 'AIzaSyAAoDkOehKQsnRVyJioGhQ9hsqZquZVnWc',
    authDomain: 'triarc-cloud.firebaseapp.com',
    projectId: 'triarc-cloud',
    storageBucket: 'triarc-cloud.appspot.com',
    messagingSenderId: '619412831763',
    appId: '1:619412831763:web:f02b0b6c90aece37c4c9e6',
  },
  disabledModules: [] as string[],
};
